module.exports = __webpack_public_path__ + "static/media/1002228.361a52ca.png";